import { render } from "./Footer.vue?vue&type=template&id=79837dba&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./footer.scss?vue&type=style&index=0&id=79837dba&lang=scss&scoped=true"

import exportComponent from "/Users/mac/lavide-pro2/lavideo-pages/noka/lwInno.com /node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79837dba"]])

export default __exports__